import crypto from 'crypto'

export const getmd5 = params =>{
    var md5 = crypto.createHash("md5");
    md5.update(params);
    return md5.digest('hex');
}


// WEBPACK FOOTER //
// ./src/global/globalMethod.js